export * from './aside.directive';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/directives/aside/index.ts